import { corsproxyRequest } from "./corsproxyRequest";

interface NominatimFeature {
  type: 'Feature';
  properties: {
    name: string;
    admin_level: string;
    type: string;
    display_name: string;
    postcode?: string;
  };
  geometry: any; // GeoJSON geometry
}

interface NominatimResponse {
  place_id: number;
  licence: string;
  osm_type: string;
  osm_id: number;
  boundingbox: string[];
  lat: string;
  lon: string;
  display_name: string;
  class: string;
  type: string;
  importance: number;
  icon?: string;
  address?: {
    postcode?: string;
    [key: string]: string | undefined;
  };
  geojson?: any;
}

export const searchNominatim = async (
  searchQuery: string,
  options: {
    countryCode?: string;
    stateCode?: string;
    filterTypes?: string[];
  } = {}
): Promise<NominatimFeature[]> => {
  const { countryCode = 'Deutschland', stateCode, filterTypes = ['administrative', 'city', 'suburb', 'postcode'] } = options;

  try {
    // Construct the query with state and country
    let fullQuery = searchQuery;
    if (stateCode) {
      fullQuery = `${fullQuery}, ${stateCode}`;
    }
    if (countryCode) {
      fullQuery = `${fullQuery}, ${countryCode}`;
    }

    const nominatimUrl = `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(
      fullQuery
    )}&format=json&polygon_geojson=1&addressdetails=1`;


    // Then encode it for the CORS proxy
    // const proxyUrl = `https://corsproxy.io/?${encodeURIComponent(nominatimUrl)}`;
    const response: NominatimResponse[] = await corsproxyRequest(nominatimUrl);



    if (!Array.isArray(response)) {
      console.error('Invalid response format:', response);
      throw new Error('Invalid response format from Nominatim');
    }

    // Convert Nominatim results to GeoJSON features
    const features = response
      .filter(item => 
        item.geojson && (
          filterTypes.includes(item.type) ||
          (item.address?.postcode && filterTypes.includes('postcode'))
        ) && 
        // Only include Polygons and MultiPolygons
        (item.geojson.type === 'Polygon' || item.geojson.type === 'MultiPolygon')
      )
      .map(item => ({
        type: 'Feature' as const,
        properties: {
          name: item.display_name.split(',')[0],
          admin_level: item.type === 'postcode' ? 'postcode' : (item.type || 'unknown'),
          type: item.osm_type,
          display_name: item.display_name,
          postcode: item.address?.postcode
        },
        geometry: item.geojson
      }));

    console.log('Filtered polygon features:', features);
    return features;
  } catch (error) {
    console.error('Error in searchNominatim:', error);
    // Provide more specific error message to the user
    if (error instanceof TypeError && error.message === 'Failed to fetch') {
      throw new Error('Network error: Unable to connect to the geocoding service. Please check your internet connection.');
    }
    throw error;
  }
}; 